import React from 'react'
import instagramIcon from '../../../assets/images/front/svg/instagram.svg'
import facebookIcon from '../../../assets/images/front/svg/facebook.svg'
import youtubeIcon from '../../../assets/images/front/svg/youtube.svg'
import tiktokIcon from '../../../assets/images/front/svg/tiktok.svg'
import { Link } from 'react-router-dom'
import { routesURLs } from '../../../Routes'

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-[#DADADA] w-full mt-12 py-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-12 text-center">
          <div className="col-span-3 hidden md:block"></div>
          <div className="col-span-6 md:col-span-3">
            <h4 className="text-[#0183BA] mb-3 text-xl md:text-[25px]">Kam dál?</h4>
            <ul className="is-pure-list">
              <li>
                <Link to={routesURLs.pkAll} className="cursor-pointer hover:underline font-myriad">
                  Přípravné kurzy
                </Link>
              </li>
              <li>
                <Link to={routesURLs.pnAll} className="cursor-pointer hover:underline font-myriad">
                  Přijímačky nanečisto
                </Link>
              </li>
              <li>
                <Link
                  to={routesURLs.onlineSchool}
                  className="cursor-pointer hover:underline font-myriad"
                >
                  Online škola
                </Link>
              </li>
              <li>
                <Link
                  to={routesURLs.privateClass}
                  className="cursor-pointer hover:underline font-myriad"
                >
                  Doučování
                </Link>
              </li>
              <li>
                <Link to={routesURLs.blog} className="cursor-pointer hover:underline font-myriad">
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to={routesURLs.contact}
                  className="cursor-pointer hover:underline font-myriad"
                >
                  Kontakty
                </Link>
              </li>
              <li>
                <Link
                  to={routesURLs.aboutUs}
                  className="cursor-pointer hover:underline font-myriad"
                >
                  O nás
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-3">
            <h4 className="text-[#0183BA] mb-3 text-xl md:text-[25px]">Kontakty</h4>
            <ul className="is-pure-list">
              <li>
                <a href="mailto:info@dohlavy.cz" className="hover:underline font-myriad">
                  info@dohlavy.cz
                </a>
              </li>
              <li>
                <a href="tel:+420774504011" className="hover:underline font-myriad">
                  +420 774 504 011
                </a>
              </li>
              <li className="flex items-center justify-center mt-2">
                <a href="https://www.tiktok.com/@dohlavy_online" target="_blank" className="me-2">
                  <img src={tiktokIcon} alt="" />
                </a>
                <a href="https://www.youtube.com/@Dohlavy_online" target="_blank" className="me-2">
                  <img src={youtubeIcon} alt="" />
                </a>
                <a href="https://www.facebook.com/Dohlavy" target="_blank" className="me-2">
                  <img src={facebookIcon} alt="" />
                </a>
                <a href="https://www.instagram.com/dohlavy_online/" target="_blank">
                  <img src={instagramIcon} alt="" />
                </a>
              </li>
            </ul>
            <ul className="text-[#979797] font-myriad gap-4 md:hidden mt-4 is-pure-list">
              <li>
                <a href="/docs/PODMINKY.pdf" target="_blank" className="hover:underline">
                  Obchodní podmínky
                </a>
              </li>
              <li>
                <Link to={routesURLs.gdpr} className="cursor-pointer hover:underline">
                  Ochrana osobních údajů
                </Link>
              </li>
              <li>
                <a href="https://skoliciprostor.cz/" target="_blank" className="hover:underline">
                  Pronájem prostor
                </a>
              </li>
              <li>
                <a
                  href="https://lektor.dohlavy.cz/sign/in"
                  target="_blank"
                  className="hover:underline"
                >
                  Přihlášení pro lektory
                </a>
              </li>
            </ul>
          </div>
          <div className="col-span-12 justify-center mt-10 hidden md:flex">
            <ul className="flex items-center text-[#979797] font-myriad gap-4 is-pure-list">
              <li>
                <a href="/docs/PODMINKY.pdf" target="_blank" className="hover:underline">
                  Obchodní podmínky
                </a>
              </li>
              <li>
                <Link to={routesURLs.gdpr} className="cursor-pointer hover:underline">
                  Ochrana osobních údajů
                </Link>
              </li>
              <li>
                <a href="https://skoliciprostor.cz/" target="_blank" className="hover:underline">
                  Pronájem prostor
                </a>
              </li>
              <li>
                <a
                  href="https://lektor.dohlavy.cz/sign/in"
                  target="_blank"
                  className="hover:underline"
                >
                  Přihlášení pro lektory
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
